import React from 'react';

import { Notifications } from '@betterment/shared-components';
import { SectionLayout } from '@betterment/style-closet-react';

import { ApplicationLayout } from '../BettermentForAdvisors/ApplicationLayout';

interface LayoutComposition {
  Header: React.FC<React.PropsWithChildren>;
  Content: React.FC<React.PropsWithChildren>;
}

interface LayoutProps {
  children: React.ReactNode;
  active: string;
}

const LayoutHeader: React.FC<React.PropsWithChildren> = ({ children }) => {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

const LayoutContent: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <SectionLayout>
      <SectionLayout.ContentWrapper>
        <Notifications css={{ paddingBottom: 'space.200' }} />
        {children}
      </SectionLayout.ContentWrapper>
    </SectionLayout>
  );
};

export const Layout: React.FC<LayoutProps> & LayoutComposition = ({ active, children }) => {
  return <ApplicationLayout active={active}>{children}</ApplicationLayout>;
};

Layout.Header = LayoutHeader;
Layout.Content = LayoutContent;
